const baseURL = `${process.env.VUE_APP_SERVER_URL}/DadosSaude`;

export async function AnalisarImagemSkinive({ vinculo, UrlImagem }: { vinculo?: string; UrlImagem: string }) {
  return globalThis.window.$axios
    .post({
      url: `${baseURL}/AnalisarImagemSkinive`,
      query: {
        vinculo
      },
      data: {
        UrlImagem
      }
    })
    .then((resp: any) => resp.data)
    .catch((error: any) => {
      globalThis.window.$log?.error?.("AnalisarImagemSkinive", error?.message || error);
      throw error;
    });
}

export async function ListarChamadosSkinive({ vinculo }: { vinculo?: string }) {
  return globalThis.window.$axios
    .get({
      url: `${baseURL}/ListarChamadosSkinive`,
      query: {
        vinculo
      }
    })
    .then((resp: any) => resp.data)
    .catch((error: any) => {
      globalThis.window.$log?.error?.("ListarChamadosSkinive", error?.message || error);
      throw error;
    });
}
